import React from "react";

export function PreviewImage(props) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Set a higher value to ensure it's above the sidebar
      }}
      onClick={props.onClick}
    >
      <img
        src={props.src}
        alt="Preview"
        style={{ maxWidth: "80%", maxHeight: "90%" }}
      />
    </div>
  );
}
